import { authHeader, handleResponse } from "./helper";
import config from "../config";

export const getMercadopagoUrl = async (params) => {
  const url = new URL(`${config.apiPaymentUrl}/mercadopago/create`);
  const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeader(),
      },
      body: JSON.stringify({
        reservation_id: params.reservationId,
        reservation_number: params.reservationNumber,
        items: params.items,
        company_id: params.companyId,
        company_foreigner: params.companyForeigner,
        reservation: params.reservation,
        secondary_email: params.secondaryEmail,
      })
  };

  return await fetch(url, requestOptions).then(handleResponse);
}

export const getTokuPaymentList = async (params) => {
  const url = new URL(`${config.apiPaymentUrl}/toku/paymentListByReservation`);

  if (params.reservationNumber) {
    url.searchParams.append('reservation_number', params.reservationNumber);
  }

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  return await fetch(url, requestOptions).then(handleResponse);
}

export const getMercadopagoPaymentList = async (params) => {
  const url = new URL(`${config.apiPaymentUrl}/mercadopago/paymentListByReservation`);

  if (params.reservationNumber) {
    url.searchParams.append('reservation_number', params.reservationNumber);
  }

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  return await fetch(url, requestOptions).then(handleResponse);
}

export const createTokuInvoice = async (params) => {
  const url = new URL(`${config.apiPaymentUrl}/toku/createInvoice`);
  const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeader(),
      },
      body: JSON.stringify({
        companyId: params.companyId,
        reservationId: params.reservationId,
        amount: params.amount,
        documentType: params.documentType
      })
  };

  return await fetch(url, requestOptions).then(handleResponse);
}
